/** Mirrors server PRICE_CHANGE_SOURCES in productPriceHistory.js */
export const PRICE_CHANGE_SOURCE_CODES = {
  DASHBOARD_EDIT: 'dashboard_edit',
  RECEIPTING_PRODUCT_EDIT: 'receipting_product_edit',
  INVOICE_RECONCILIATION: 'invoice_reconciliation',
  BULK_PRICE_FILE: 'bulk_price_file',
  CSV_UPLOAD: 'csv_upload',
  SCHEDULED_PRICE_FILE: 'scheduled_price_file',
}

const PRICE_CHANGE_SOURCE_LABELS = {
  [PRICE_CHANGE_SOURCE_CODES.DASHBOARD_EDIT]: 'Dashboard edit',
  [PRICE_CHANGE_SOURCE_CODES.RECEIPTING_PRODUCT_EDIT]: 'Receipting',
  [PRICE_CHANGE_SOURCE_CODES.INVOICE_RECONCILIATION]: 'Invoice reconciliation',
  [PRICE_CHANGE_SOURCE_CODES.BULK_PRICE_FILE]: 'Bulk price file',
  [PRICE_CHANGE_SOURCE_CODES.CSV_UPLOAD]: 'CSV upload',
  [PRICE_CHANGE_SOURCE_CODES.SCHEDULED_PRICE_FILE]: 'Scheduled price file',
  unknown: 'Unknown',
}

/** Human-readable label for a price audit source code. */
export const formatAuditSource = source => {
  const key = typeof source === 'string' ? source.trim() : ''
  if (!key) return PRICE_CHANGE_SOURCE_LABELS.unknown
  return PRICE_CHANGE_SOURCE_LABELS[key] || PRICE_CHANGE_SOURCE_LABELS.unknown
}
